import React, { useState } from "react";
import { FaCopy, FaTrash } from "react-icons/fa";
import JSONPretty from "react-json-pretty";
import { toast, ToastContainer } from "react-toastify";

const WebsiteSchemaForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    url: "",
    searchUrl: "",
    searchQueryString: "",
  });

  const [generatedSchema, setGeneratedSchema] = useState({
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "",
    "url": "",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "{}",
      "query-input": "required name="
    }
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const generateSchema = () => {
    const schema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": formData.name,
      "url": formData.url,
      "potentialAction": {
        "@type": "SearchAction",
        "target": `${formData.searchUrl}{${formData.searchQueryString}}`,
        "query-input": `required name=${formData.searchQueryString}`,
      },
    };

    setGeneratedSchema(JSON.stringify(schema, null, 2));
  };

  const handleCopySchema = () => {
    navigator.clipboard.writeText(generatedSchema);
    toast.info("Schema copied to clipboard!");
  };

    const deleteSchema = () => {
      setGeneratedSchema({
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "",
        "url": "",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "{}",
          "query-input": "required name="
        }
      });
      toast.warning("Schema reset to dummy data!");
    };
    
  const handleSubmit = (e) => {
    e.preventDefault();
    generateSchema();
  };

  return (
    <div className="container mt-4">
     <ToastContainer/>
     <div className="row">
      <div className="col-md-6">
      <h3 className="mb-4">Website Schema Generator</h3>
      <form onSubmit={handleSubmit} className="card p-4 shadow-sm">
        {/* Website Details */}
        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">Website's Name</label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Enter website's name"
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">URL</label>
            <input
              type="text"
              className="form-control"
              name="url"
              value={formData.url}
              onChange={handleInputChange}
              placeholder="Enter website URL"
            />
          </div>
        </div>

        {/* Search Action Details */}
        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">Internal Site Search URL</label>
            <input
              type="text"
              className="form-control"
              name="searchUrl"
              value={formData.searchUrl}
              onChange={handleInputChange}
              placeholder="e.g., https://example.com/search?q="
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Query Input Parameter</label>
            <input
              type="text"
              className="form-control"
              name="searchQueryString"
              value={formData.searchQueryString}
              onChange={handleInputChange}
              placeholder="e.g., search_term_string"
            />
          </div>
        </div>

        {/* Submit Button */}
        <button type="submit" className="btn btn-success w-100">
          Generate Schema
        </button>
      </form>
      </div>
      <div className="col-md-6">
 {/* JSON-LD Preview and Actions */}
 {generatedSchema && (
        <div className="mt-4">
          <h5>Generated JSON-LD:</h5>
          <div className="d-flex justify-content-center align-items-center mb-3 mt-3">
  <button className="btn btn-primary me-2" onClick={handleCopySchema}>
    Copy
  </button>
  <button className="btn btn-danger me-2" onClick={deleteSchema}>
    Reset
  </button>
  <button className="btn btn-info me-2">
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none text-white"
      href="https://developers.google.com/search/docs/appearance/structured-data"
    >
      Validate
    </a>
  </button>
  <button className="btn btn-success">
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none text-white"
      href="https://search.google.com/test/rich-results"
    >
      Test
    </a>
  </button>
</div>
          <JSONPretty
                  id="json-pretty"
                  data={generatedSchema}
                  className="bg-light p-3 rounded border"
                ></JSONPretty>
        
        </div>
      )}
      </div>

     </div>

     
    </div>
  );
};

export default WebsiteSchemaForm;
